module.exports = __webpack_public_path__ + "0471728756bc0a9d55ed3ab77e0967b8.pdf";